/** 新标签打开 Templates 列表，并按 Publisher（真人）筛选 */
export function openTemplatesByPublisher(publisherId) {
  if (!publisherId) return
  window.open(
    `/admin?tplTab=templates&publisher=${encodeURIComponent(publisherId)}`,
    '_blank',
    'noopener,noreferrer',
  )
}

/** 新标签打开 Onlines 列表，并按 Painter（假人）筛选 */
export function openOnlinesByPainter(painterId) {
  if (!painterId) return
  window.open(
    `/admin?tplTab=onlines&author=${encodeURIComponent(painterId)}`,
    '_blank',
    'noopener,noreferrer',
  )
}
